<template>
  <v-card>
    <!-- <v-card-title>User Login</v-card-title> -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>edit</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Edit Trade Name</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%;">
      <v-form ref="editTradeForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex xs12>
            <v-text-field
              outline
              label="Trade Name *"
              required
              v-model="editItem.name"
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          
          <v-textarea v-model="editItem.notes" outline label="Note"></v-textarea>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="editItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
      >Update</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["editItem"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    validate() {
      if (this.$refs.editTradeForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.editTradeForm.reset();
    },
    resetValidation() {
      this.$refs.editTradeForm.resetValidation();
    },
    clearForm() {
      this.newItem.name = "";
      this.newItem.notes = "";
    },
    editItemDo() {
      if (this.$refs.editTradeForm.validate()) {
        this.actionButtonClicked = true;
        this.put("/trade", this.editItem).then(res => {
          if (res.data.success) {
            this.onCancelled();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    }
  },
  mounted() {
  }
};
</script>